import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Transporte = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="EQUIPE DE TRANSPORTE" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Transporte de Pacientes" nome="transportepac" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="26vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Tipo" nome="transportetipo" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                            array={["Intra-Hospitalar", "Extra-Hospitalar", "Ambos"]} />
                        <Input label="Nº de Pacientes Assistidos" nome="transporteassist" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes no Momento da Fiscalização" nome="transportfisc" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                    </div>


                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="Fisioterapeuta no Plantão" />
                        <Input label="Quantos Fisioterapeutas no Setor" nome="transportefisioescala" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}
                    </div>

                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="Profissionais na Escala" />

                        <Input label="Assistência Fisioterapêutica 7 dias/Semanas" nome="transportesemana" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Assistência Fisioterapêutica Horas/Dias" nome="transportehrdia" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Exclusividade do Fisioterapeuta para Assistência no Setor" nome="transporteexclu" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="8vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>

                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["transportefisioescala"]
                if (array[modulo][n]["transportefisioescala"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Profissional" nome="transnomedoprofissional"
                                    modulo={modulo} index={n} subModulo="transnomedoprofissional" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Select label="Jornada de Trabalho" nome="transjornada"
                                    modulo={modulo} index={n} subModulo="transjornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Diarista", "Plantonista", "Ambos"]} />
                              
                                <Select label="Horário de Trabalho" nome="transhrtrabalho"
                                    modulo={modulo} index={n} subModulo="transhrtrabalho" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default Transporte